<template>
  <v-dialog
      v-model="item.active"
      width="600"
      @input="(v) => v || close"
  >
    <v-card>
      <v-card-title class="headline lighten-2">
        {{item.title}}
      </v-card-title>

      <v-card-text style="max-height: calc(100vh - 300px); overflow-y: scroll">
        <v-row>
          <v-col cols="1">
            <v-icon v-if="item.type === 'success'"
                    color="green darken-2"
            >
              mdi-check-bold
            </v-icon>
            <v-icon v-if="item.type === 'error'"
                    color="red darken-2"
            >
              mdi-alert-circle
            </v-icon>
          </v-col>
          <v-col cols>
            <span v-html="item.content"></span>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            depressed
            @click="close"
        >
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "InfoDialog",
  data (){
    return {
      item: store.state.infoDialog,
    }
  },
  methods:{
    close(){
      store.closeInfoDialog();
    },
  }
}
</script>
